//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/TaggedObject.js";
import "../no/SelectDisplayableObject.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"LimitGeometry",0,"SelectDisplayableObject",0],[0,"LimitMethod",1,0],[0,"LimitPlane",1,"Plane",0],[1,"LimitValue",0,"Expression",0],[1,"SquareCutClearance",0,"Expression",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.ShipDesign.StiffenerLimitBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.StiffenerLimitBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.StiffenerLimitBuilder.LimitType = Object.freeze({
    "Value" : "Value", "SquareCut" : "SquareCut", "NeatTrim" : "NeatTrim", "Boundary" : "Boundary"});

export default SPLM;